import Vue from 'vue'
import axios from 'axios'
import ApiIncoming from './Incoming/Incoming'
import { Auth } from '../services/Oidc'

// @ts-ignore
import Variables from '../styles/variables.scss'
import { interceptorConfig } from './interceptor-config'

export default class Interceptor {
  constructor() {
    axios.defaults.headers.delete['Content-Type'] = 'application/json'
    axios.defaults.headers.get['Content-Type'] = 'application/json'
    axios.defaults.headers.get['Cache-Control'] = 'no-cache'
    axios.defaults.headers.post['Content-Type'] = 'application/json'
    axios.defaults.headers.put['Content-Type'] = 'application/json'
  }

  token: string = ''
  usuario: Object = {}

  private async defineHeader() {
    const token = await Auth.getAccessToken()
    this.token = token

    axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
  }

  async delete(url: string, headers: object) {
    await this.defineHeader()

    try {
      const response = await axios.delete(url, headers)
      return response
    } catch (error) {
      this.fail(error, null, headers)
      return error
    }
  }

  async get(url: string, config: object) {
    await this.defineHeader()

    try {
      const response = await axios.get(url, config)
      return response
    } catch (error) {
      this.fail(error)
      return error
    }
  }

  async getAllowAnonymous(url: string, config: object) {
    try {
      const response = await axios.get(url, config)
      return response
    } catch (error) {
      this.failAnonymous(error)
      return error
    }
  }

  async post(url: string, data: any, headers: object) {
    await this.defineHeader()

    try {
      const response = await axios.post(url, data, headers)
      return response
    } catch (error) {
      this.fail(error, data, headers)
      return error
    }
  }

  async postAllowAnonymous(url: string, data: any, headers: object) {
    try {
      const response = await axios.post(url, data, headers)
      return response
    } catch (error) {
      this.failAnonymous(error, data)
      return error
    }
  }

  async put(url: string, data: any, headers: object) {
    await this.defineHeader()

    try {
      const response = await axios.put(url, data, headers)
      return response
    } catch (error) {
      this.fail(error, data, headers)
      return error
    }
  }

  async getUser() {
    const user = await Auth.getUser()
    return user.profile
  }

  async fail(error, data?, headers?) {
    const response = error.response.data
    const status = error.response.status
    const url = error.response.config.url

    const interceptorStatusCodeError = interceptorConfig.getInterceptorStatusCodeError(status)

    if (interceptorStatusCodeError) {
      interceptorStatusCodeError(url, status, data, headers, response, () => this.failNext(url, status, data, headers))
    } else {
      this.failNext(url, status, data, headers)
    }
  }

  async failAnonymous(error, data?, headers?) {
    const response = error.response.data
    const status = error.response.status
    const url = error.response.config.url

    const interceptorStatusCodeError = interceptorConfig.getInterceptorStatusCodeError(status)

    if (interceptorStatusCodeError) {
      interceptorStatusCodeError(url, status, data, headers, response, () => this.failNext(url, status, data, headers))
    } else {
      this.failNext(url, status, data, headers)
    }
  }

  async failNext(url: string, status: number, data: any, headers: any) {
    switch (status) {
      case 401:
        await Auth.login('/')
        break

      case 500:
        this.sendAlert(url, status, data, headers)
        break;

      default:
        if (interceptorConfig.hasAdditionalStatusCodeError(status)) {
          this.sendAlert(url, status, data, headers)
        }
        break;
    }
  }


  async sendAlert(url?: String, status?: Number, data?, headers?) {
    const user = await this.getUser()

    const detail = `
      URL: ${url}
      Código: ${status}
      Usuário: ${user.email}
      Data: ${JSON.stringify(data)}
      Headers: ${JSON.stringify(headers)}
    `

    const message = {
      title: 'Erro na API',
      text: detail,
      themeColor: Variables.clError,
    }

    ApiIncoming.Alert.sendAlert(message)
  }

  async sendAlertAnonymous(url?: String, status?: Number, data?, headers?) {
    const detail = `
      URL: ${url}
      Código: ${status}
      Data: ${JSON.stringify(data)}
      Headers: ${JSON.stringify(headers)}
    `
    const message = {
      title: 'Erro na API',
      text: detail,
      themeColor: Variables.clError,
    }

    ApiIncoming.Alert.sendAlert(message)
  }
}
